import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import * as Linking from "expo-linking";
import { Feather } from "@expo/vector-icons";

import type { SettingItem } from "@/schemas/screen/settings";

type SettingsOptionProps = {
  item: SettingItem;
};

const SettingsOption = ({ item }: SettingsOptionProps): React.JSX.Element => {
  const handleItemAction = (): void => {
    if (item.navigateTo) {
      item.navigateTo();
    } else if (item.link) {
      Linking.openURL(item.link);
    }
  };

  return (
    <TouchableOpacity style={[styles.container]} onPress={handleItemAction}>
      <View style={styles.iconContainer}>
        <Text style={styles.itemName}>{item.emoji}</Text>
      </View>
      <Text
        testID={item.name.toLowerCase().replace(/ /g, "-")}
        style={styles.itemName}
      >
        {item.name}
      </Text>
      <Feather name="chevron-right" size={20} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    padding: 8,
  },
  iconContainer: {
    marginRight: 15,
  },
  itemName: {
    flex: 1,
    fontSize: 16,
  },
});

export default SettingsOption;
